__turbopack_context__.v({
  "editorial": "styles-module-scss-module__6uXOza__editorial",
  "grid": "styles-module-scss-module__6uXOza__grid",
  "icon": "styles-module-scss-module__6uXOza__icon",
  "logo": "styles-module-scss-module__6uXOza__logo",
  "min-columns-1": "styles-module-scss-module__6uXOza__min-columns-1",
});
